import { render } from "./IconChevronDown.vue?vue&type=template&id=005a50da"
import script from "./IconChevronDown.vue?vue&type=script&lang=js"
export * from "./IconChevronDown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__